<template>
  <div class="projects">
    <div class="row">
      <Project v-bind="projects[0]"/>
      <Project v-bind="projects[1]"/>
    </div>
    <!-- <div class="row">
      <Project v-bind="projects[2]"/>
      <Project v-bind="projects[3]"/>
    </div> -->
  </div>
</template>

<script>
import Project from '@/components/Project.vue';

export default {
  name: 'ProjectsView',
  components: {
    Project,
  },
  data: () => ({
    projects: [
      {
        name: 'Visualizations',
        description: 'a collection of data visualizations',
        imageUrl: 'blog_ss.png',
        link: 'http://www.jpecht.com/vis',
      }, {
        name: 'LCR',
        description: 'an online dice game',
        imageUrl: 'life-game-screenshot.png',
        link: 'http://www.jpecht.com/lcr',
      }, {
        name: 'GHS Tracking Dashboard',
        description: 'a global health security funding analysis tool',
        imageUrl: 'tracking_ss.png',
        link: 'https://tracking.ghscosting.org',
      }, {
        name: 'IHR Costing Tool',
        description: 'a country-level health security costing tool',
        imageUrl: 'ihr_ss.png',
        link: 'https://demo.ghscosting.org',
      },
    ],
  }),
};
</script>

<style scoped>
.row {
  display: flex;
  margin-left: -20px;
  margin-right: -20px;
}
</style>
